import { Box, Button, FormControl, IconButton, InputAdornment, Modal, TextField, Typography } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import DataTablePersons from './components/DataTablePersons'
import toaster from '../../toaster'
import { useCreateKycV2PersonMutation } from '../../features/kycv2/kycv2Slice'
import CreatePersonForm from './components/CreatePersonForm'
import useDebounce from '../../components/hooks/useDebounce'
import styles from './styles.module.scss'

export const KycV2 = () => {
  const { t } = useTranslation(['common', 'messages'])
  const [searchText, setSearchText] = useState()
  const [showCreatePersonModal, setShowCreatePersonModal] = useState(false)

  const [createKycV2Person] = useCreateKycV2PersonMutation({ fixedCacheKey: 'create-person-v2' })

  const searchTextDebounced = useDebounce(searchText, 500)

  const onSubmit = async (values) => {
    const { email, firstname, lastname, externalId, webhookUrl, metadata } = values

    try {
      const payload = {
        firstname,
        lastname,
      }

      if (email) payload.email = email
      if (externalId) payload.externalId = externalId
      if (webhookUrl) payload.webhookUrl = webhookUrl
      if (metadata) payload.metadata = metadata

      await createKycV2Person({
        body: payload,
      }).unwrap()
      toaster.success(t('messages:createKycPersonSuccess'))
      setShowCreatePersonModal(false)
    } catch (error) {
      console.error('[CREATE NEW PERSON V2 ERROR] --> ', error?.data?.data)
      toaster.error(t('messages:createKycPersonError'))
    }
  }

  return (
    <Box className={`${styles.container} filter`}>
      <Typography variant="h2" className={styles.pageTitle}>
        {t('common:KYC')} V2 - {t('common:knowYourClient')}
      </Typography>
      <Box className={styles.actionsContainer}>
        <FormControl sx={{ m: 1, width: 350 }}>
          <TextField
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={() => {}}
            placeholder={t('messages:searchKycPersonByEmailOrName')}
            variant="outlined"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton alt="Clear" disabled={!searchText} onClick={() => setSearchText('')}>
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </FormControl>
        <Button variant="contained" onClick={() => setShowCreatePersonModal(true)}>
          {`${t('common:create')} ${t('common:person')}`}
        </Button>
      </Box>
      <Box className={styles.tableContainer}>
        <DataTablePersons text={searchTextDebounced} />
      </Box>
      <Modal open={showCreatePersonModal} onClose={() => setShowCreatePersonModal(false)}>
        <div>
          <CreatePersonForm onSubmit={onSubmit} onCancel={() => setShowCreatePersonModal(false)} />
        </div>
      </Modal>
    </Box>
  )
}
